import React, { Component } from "react";
import { Field, Form, Formik } from "formik";
import { FormGroup, Label, Button } from "reactstrap";
import { isEmpty } from "lodash";
import { SimpleInput, DefaultObject } from "@gsd/backoffice-ui";

import * as Yup from "yup";

const ValidateSchema = Yup.object().shape({
  description: Yup.string().required("Campo obbligatorio"),
  name: Yup.string().required("Campo obbligatorio"),
  rolePostfix: Yup.string().required("Campo obbligatorio"),
});

type FormProps = {
  onSubmit: any;
  initialValues?: {
    //uid: number,
    description: string;
    name: string;
    rolePostfix: string;
  };
};

export default class FormRole extends Component<FormProps> {
  static defaultProps: FormProps = {
    onSubmit: (values) => {
      console.log(values);
    },
  };

  render() {
    const { initialValues } = this.props;
    if (isEmpty(initialValues)) return null;
    const defaultValues = {
      uid: 0,
      description: "",
      name: "",
      rolePostfix: "",
      acl: "",
    };

    const formValues = DefaultObject(initialValues, defaultValues);

    return (
      <Formik
        initialValues={formValues}
        validationSchema={ValidateSchema}
        validateOnBlur
        isInitialValid={true}
        onSubmit={this.props.onSubmit}
      >
        {(formmikProps) => {
          return (
            <Form>
              <input type="hidden" value={0} name="id" />
              <FormGroup>
                <Label for="name">Nome</Label>
                <Field name="name" type={"text"} component={SimpleInput} />
              </FormGroup>
              <FormGroup>
                <Label for="description">Descrizione ruolo</Label>
                <Field
                  name="description"
                  type={"text"}
                  component={SimpleInput}
                />
              </FormGroup>
              <FormGroup>
                <Label for="rolePostfix">Suffisso </Label>
                <Field
                  name="rolePostfix"
                  type={"text"}
                  component={SimpleInput}
                />
              </FormGroup>
              <div className="text-center">
                <Button
                  color="primary"
                  size="lg"
                  className="px-5"
                  type="submit"
                  disabled={!formmikProps.isValid || formmikProps.isSubmitting}
                >
                  Salva
                </Button>
              </div>
            </Form>
          );
        }}
      </Formik>
    );
  }
}
